exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".y-fade-enter,.y-fade-leave-to{opacity:.1}.y-fade-enter-to,.y-fade-leave{opacity:1}.y-fade-enter-active,.y-fade-leave-active{transition:.2s ease-out}.y-scale-x-enter,.y-scale-x-leave-to{opacity:0;transform:scaleX(0)}.y-scale-x-enter-to,.y-scale-x-leave{opacity:1;transform:scale(1)}.y-scale-x-enter-active,.y-scale-x-leave-active{transform-origin:0 0;transition:.25s ease-out;transition:var(--transition) ease-out}", ""]);

// exports
